import React from 'react';

import { getValueWithEllipsis } from '@/src//util/strings';
import Tooltip from '@/src/components/common/Elements/Tooltip/Tooltip';
import { DEFAULT_NULL_VALUE } from '@/src/components/project/Inbox2/Config/inbox.config';

type CollapsedListProps = {
  items: string[];
  tooltipKey: string;
  maxLength?: number;
};

const CollapsedList = ({ items, maxLength, tooltipKey }: CollapsedListProps) => {
  if (items.length < 1) {
    return <React.Fragment>{DEFAULT_NULL_VALUE}</React.Fragment>;
  }

  const tooltipId = `tooltip_${tooltipKey}`;

  const isMultiple = items.length > 1;
  const firstItem = items[0];
  const firstItemWithEllipsis = getValueWithEllipsis(firstItem, maxLength);

  return (
    <React.Fragment>
      <span data-tooltip-id={tooltipId} className="mb0" key={`tag_${firstItem}`}>
        {firstItemWithEllipsis}
        {isMultiple && (
          <React.Fragment>
            <span>+ {items.length - 1} </span>
            <Tooltip id={tooltipId} place="bottom" effect="solid">
              {firstItem.length > 16 ? firstItem : ''}
              {items.slice(1, items.length).map((item, index) => (
                <div key={`{${item}_${index}`}>{item}</div>
              ))}
            </Tooltip>
          </React.Fragment>
        )}
      </span>
    </React.Fragment>
  );
};

export default CollapsedList;
